<template>
  <div class="news-detail-wrap">
      <div class="news-detail_box">
        <div class="news-detail_breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/news'}">新闻资讯</el-breadcrumb-item>
            <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <h3 class="news-detail_title">{{info.title}}</h3>
        <div class="news-detail_html u-m-b-20" v-html="info.content"></div>
        <p class="news-detail-page u-m-b-12" v-if="info.prev_news != false" @click="toLink(info.prev_news)">上一篇：{{info.prev_news.title}}</p>
        <p class="news-detail-page" v-if="info.next_news != false"  @click="toLink(info.next_news)">下一篇：{{info.next_news.title}}</p>
      </div>
  </div>
</template>

<script>
import {format_html} from "@/utils/tool"
export default {
    data(){
        return {
            info:{
              prev_news:false,
              next_news:false
            }
        }
    },
    mounted(){
        this.getDetailFun()
    },
    methods:{
        toLink(item){
            this.$to_redirect('detail',{id:item.id},2)
        },
        //获取详情
        getDetailFun(){
            this.$http.get('index_newsDetail',{id:this.$route.params.id}).then(res=>{
                if(res.code == 1){
                    res.data.content = format_html(res.data.content)
                    this.info = res.data
                }
            })
        }
    }
}
</script>
<style lang="scss">
.news-detail-wrap{
    min-height: 500px;
    padding-bottom: 20px;
    .news-detail_box{
        width: $width;
        margin: 0 auto;
        .news-detail_breadcrumb{
            display: flex;
            align-items: center;
            height: 75px;
            border-bottom: 1px solid #EEEEEE;
        }
        .news-detail_title{
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 26px;
            color: #222222;
            padding-top: 30px;
            padding-bottom: 30px;
            text-align: center;
        }
        .news-detail_html{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: #666666;
            padding-bottom: 50px;
            border-bottom: 1px solid #EEEEEE;
        }
        .news-detail-page{
          cursor: pointer;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          color: #666666;
        }
    }
}
</style>
